/**
 * Faol bandning chap chekkasidagi belgi — admin panelida ham, kabinetda ham
 * bir xil.
 *
 * Ilgari faol band `bg-blue-600/20` fon va `text-white` bilan belgilanardi:
 * ko'k rang palitradan tashqarida edi va yashil yon panel ustida begona
 * ko'rinardi, oq matn esa yorug' mavzudagi mobil sheet ichida o'qilmasdi.
 * Endi hammasi yon panel tokenlaridan: fon `--sidebar-accent`, matn
 * `--sidebar-accent-foreground`, chekkadagi belgi `--sidebar-primary`.
 *
 * Belgi tugmada emas, `<li>` da (`data-active` bilan birga beriladi):
 * tugmaning `overflow-hidden` i (yig'ilgan panelda yorliqni yashiradi)
 * tugmadan tashqaridagi belgini kesib tashlardi va u hech qachon
 * ko'rinmasdi. Balandligi qat'iy (`top-1 h-6`, qator 2rem): ochilgan guruhda
 * belgi bolalar ro'yxati bo'ylab cho'zilmasdan, ota qator yonida qoladi.
 */
export const ACTIVE_MARKER =
  "data-active:before:absolute data-active:before:top-1 data-active:before:-left-2 " +
  "data-active:before:h-6 data-active:before:w-1 data-active:before:rounded-full " +
  "data-active:before:bg-sidebar-primary";
